import React from 'react';
import { PageHead, Section, Eyebrow, PageTitle, Lede, Button } from '../components/ui';

const NotFoundPage = () => (
  <>
    <PageHead title="Page not found" description="That page is not here." path="/404" />
    <Section tone="page" reveal={false}>
      <Eyebrow>404</Eyebrow>
      <PageTitle>That page is not here.</PageTitle>
      <Lede>The site was rebuilt in September 2026 and some older links moved. Try the pages below.</Lede>
      <div className="mt-8 flex flex-wrap gap-3">
        <Button to="/">Home</Button>
        <Button to="/what-we-do" variant="secondary">What we do</Button>
        <Button to="/book" variant="secondary">The Book</Button>
      </div>
    </Section>
  </>
);

export default NotFoundPage;
